import { Cell } from '@pelckmans/elementis/components/table/cell';
import CalendarIcon from '@pelckmans/elementis/icons/calendar';
import { ComponentProps } from 'react';
import { formatDate } from '../../../../../../utils/formatDate';

export default function DateCell({
  completedBySystem,
  isZeroScore,
  achievedAt,
  highlighted,
}: {
  completedBySystem: boolean;
  isZeroScore: boolean;
  achievedAt?: string;
} & Pick<ComponentProps<typeof Cell>, 'highlighted'>) {
  return (
    <Cell minWidth="sm" maxWidth="sm" highlighted={highlighted}>
      {!(completedBySystem && isZeroScore) && achievedAt ? (
        <Cell.Text startAdornment={<CalendarIcon data-testid="calendar-icon" />} title={formatDate(achievedAt)} />
      ) : null}
    </Cell>
  );
}
